/*
  Pretty in Pink: collectiegrid v2
  - cijferkiezer voor kolommen (2/3 mobiel, 3/4/6 desktop, standaard 2 en 4), onthouden per apparaat
  - Laad meer: haalt de volgende pagina op en plakt de producten eronder
  - hartjes (Growave): cirkel en schaduw weg via een stijl in de open shadow root, iets groter icoon,
    en de lijnkleur per kaart zwart of wit op basis van de helderheid rechtsboven in de productfoto
    (CSS-variabele --pip-heart); de gevulde staat bij toevoegen blijft van Growave zelf.
    De observer kijkt naar de hele pagina, zodat ook kaarten die later via AJAX binnenkomen
    (zoals de related products op de productpagina) gestyled worden.
  Snel toevoegen en videotegels zitten in assets/pip-collection.js.
  Fase 2, groep 7 (B2-30, B2-31): de standaardweergave (data-pip-view-m en data-pip-view-d op de grid) en de voortgangstekst
  (data-tpl) komen uit Thema-instellingen > PIP collectiepagina. Ontbreken ze, dan gelden de oude waarden (2 en 4).
*/
(function () {
  if (window.pipColV2Loaded) return;
  window.pipColV2Loaded = true;

  var KEY_M = 'pipv2-view-m';
  var KEY_D = 'pipv2-view-d';
  var VIEWS = ['m1', 'm2', 'm3', 'd3', 'd4', 'd6'];

  function read(key, fallback) {
    try { return window.localStorage.getItem(key) || fallback; } catch (e) { return fallback; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function applyView() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('pipv2')) return;
    var m = read(KEY_M, grid.getAttribute('data-pip-view-m') || 'm2');
    if (m === 'm1') m = 'm2';
    var d = read(KEY_D, grid.getAttribute('data-pip-view-d') || 'd4');
    VIEWS.forEach(function (v) { grid.classList.remove('pip-' + v); });
    grid.classList.add('pip-' + m, 'pip-' + d);
    document.querySelectorAll('[data-pipv2-view]').forEach(function (b) {
      var v = b.getAttribute('data-pipv2-view');
      b.setAttribute('aria-pressed', v === m || v === d ? 'true' : 'false');
    });
  }

  /* ---------- Hartjes (Growave) ---------- */
  var HEART_CSS =
    'button.gw-toggle-wishlist-product-card-button{background:transparent!important;box-shadow:none!important;width:38px;height:38px;}' +
    'svg.gw-wl-icon{width:26px;height:26px;}' +
    'svg.gw-wl-icon path[d*="M19.3684 12.1211"]{fill:var(--pip-heart,#121212);}' +
    '@media (max-width:749px){button.gw-toggle-wishlist-product-card-button{width:30px!important;height:30px!important;}svg.gw-wl-icon{width:20px!important;height:20px!important;}}';

  /* Fase 2, groep 24 (05-10-2026, snelheid): dezelfde meting als eerst (foto van 80 px, vlak rechtsboven, grens 128), maar
     - alleen voor kaarten (of een hele schuifrij) die binnen 1000 px van het scherm komen (eerst voor elke kaart op de pagina meteen een extra foto),
     - de uitkomst per foto onthouden, zodat dezelfde foto (bijvoorbeeld in twee rijen) niet twee keer wordt gemeten.
     De kleur staat dus klaar voordat de kaart in beeld komt. */
  var heartCache = {};
  var heartWait = {};
  function heartProbeUrl(imgEl) {
    var src = imgEl.currentSrc || imgEl.src || imgEl.getAttribute('src') || '';
    if (!src) return '';
    return src.split('&width=')[0] + (src.indexOf('?') > -1 ? '&' : '?') + 'width=80';
  }
  function measureHeart(url, done) {
    if (heartCache[url]) { done(heartCache[url]); return; }
    if (heartWait[url]) { heartWait[url].push(done); return; }
    heartWait[url] = [done];
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var col = '';
      try {
        var c = document.createElement('canvas');
        c.width = 40; c.height = 40;
        var ctx = c.getContext('2d');
        ctx.drawImage(probe, 0, 0, 40, 40);
        var d = ctx.getImageData(22, 2, 16, 12).data;
        var sum = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) { sum += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; n++; }
        col = sum / n < 128 ? '#ffffff' : '#121212';
      } catch (e) {}
      var list = heartWait[url] || [];
      delete heartWait[url];
      if (col) heartCache[url] = col;
      list.forEach(function (fn) { if (col) fn(col); });
    };
    probe.onerror = function () { delete heartWait[url]; };
    probe.src = url;
  }
  function sampleNow(imgEl, host) {
    try {
      var url = heartProbeUrl(imgEl);
      if (!url) return;
      measureHeart(url, function (col) { host.style.setProperty('--pip-heart', col); });
    } catch (e) {}
  }
  var heartIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      heartIO.unobserve(en.target);
      var jobs = en.target.__pipHeart || [];
      en.target.__pipHeart = null;
      jobs.forEach(function (job) { sampleNow(job.img, job.host); });
    });
  }, { rootMargin: '1000px 0px' }) : null;
  function sampleHeartColor(imgEl, host) {
    if (!heartIO) { sampleNow(imgEl, host); return; }
    /* in een schuifrij (home, Onze aanraders) de hele rij als één geheel: kaarten rechts buiten de rij krijgen hun kleur
       tegelijk met de rest, niet pas tijdens het swipen */
    var target = host.closest('[data-pip-hp-row], .pip-rel__grid') || host.closest('.pip-card2') || imgEl;
    if (!target.__pipHeart) { target.__pipHeart = []; heartIO.observe(target); }
    target.__pipHeart.push({ img: imgEl, host: host });
  }

  /* Styl een placeholder zodra Growave de shadow root heeft gezet.
     Geeft true terug zolang de shadow root er nog niet is (dan moet er opnieuw gekeken worden):
     Growave zet de shadow zonder DOM-mutatie, dus de observer hieronder ziet dat moment niet. */
  function styleOne(ph) {
    if (ph.getAttribute('data-pip-heart-done')) return false;
    if (!ph.shadowRoot) return true;
    var st = document.createElement('style');
    st.textContent = HEART_CSS;
    ph.shadowRoot.appendChild(st);
    ph.setAttribute('data-pip-heart-done', '1');
    var card = ph.closest('.pip-card2');
    var img = card && card.querySelector('.pip-card2__img');
    if (img) sampleHeartColor(img, ph);
    return false;
  }

  var heartRetry = null;
  var heartEpochs = 0; /* begrenzing zodat dit nooit eindeloos blijft pollen als Growave niet laadt */
  function styleHearts() {
    var waiting = false;
    document.querySelectorAll('.gw-add-to-wishlist-product-card-placeholder').forEach(function (ph) {
      if (styleOne(ph)) waiting = true;
    });
    /* zolang er placeholders zonder shadow root zijn (net nieuw via AJAX, bijvoorbeeld na filteren
       of Laad meer) even blijven proberen tot Growave ze heeft ingevuld */
    if (waiting && !heartRetry && heartEpochs < 40) {
      heartEpochs++;
      var tries = 0;
      heartRetry = setInterval(function () {
        tries++;
        var still = false;
        document.querySelectorAll('.gw-add-to-wishlist-product-card-placeholder').forEach(function (ph) {
          if (styleOne(ph)) still = true;
        });
        if (!still || tries > 30) { clearInterval(heartRetry); heartRetry = null; }
      }, 400);
    }
  }

  /* ---------- Saves teller live bijwerken ----------
     Houd de Growave wishlist-calls in de gaten en doe het getal onder het hartje
     van de juiste kaart plus of min 1 (zelfde aanpak als op de productpagina,
     maar dan generiek: het product-id komt uit de call zelf). */
  function bumpSaves(pid, delta) {
    document.querySelectorAll('.gw-add-to-wishlist-product-card-placeholder[data-gw-product-id="' + pid + '"]').forEach(function (ph) {
      var wrap = ph.closest('.card__wishlist-heart');
      var el = wrap && wrap.querySelector('.pip-card2__saves');
      if (!el) return;
      var n = parseInt(el.textContent, 10);
      if (isNaN(n)) return;
      n += delta;
      if (n < 0) n = 0;
      el.textContent = n;
    });
  }

  function wlPidFrom(url, body) {
    var m = String(url || '').match(/[?&]productId=(\d+)/);
    if (m) return m[1];
    try {
      var j = JSON.parse(String(body));
      var p = j.productId || (j.item && j.item.productId) || (j.data && j.data.productId);
      if (p) return String(p);
    } catch (e) {}
    var m2 = String(body || '').match(/"productId"\s*:\s*"?(\d+)/);
    return m2 ? m2[1] : null;
  }

  function wlHandle(url, body) {
    url = String(url || '');
    if (url.indexOf('wishlist-storefront') === -1) return;
    var pid;
    if (url.indexOf('deleteItem') > -1) {
      pid = wlPidFrom(url, body);
      if (pid) bumpSaves(pid, -1);
    } else if (url.indexOf('addItem') > -1) {
      pid = wlPidFrom(url, body);
      if (pid) bumpSaves(pid, 1);
    }
  }

  (function patchWlNet() {
    var of = window.fetch;
    window.fetch = function (input, init) {
      try { wlHandle(typeof input === 'string' ? input : input && input.url, init && init.body); } catch (e) {}
      return of.apply(this, arguments);
    };
    var oo = XMLHttpRequest.prototype.open;
    var os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__pipWlUrl = u; return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (b) {
      try { wlHandle(this.__pipWlUrl, b); } catch (e) {}
      return os.apply(this, arguments);
    };
  })();

  /* ---------- Laad meer ---------- */
  function updateSeen(wrap) {
    var grid = document.getElementById('product-grid');
    var seen = wrap.querySelector('[data-pip-seen]');
    var bar = wrap.querySelector('[data-pip-bar]');
    if (!grid || !seen) return;
    var shown = grid.querySelectorAll('[data-pip-item]').length;
    var total = parseInt(grid.getAttribute('data-pip-total'), 10) || shown;
    if (shown > total) shown = total;
    var tpl = seen.getAttribute('data-tpl') || 'Je hebt [gezien] van [totaal] producten gezien';
    seen.textContent = tpl.replace('[gezien]', shown).replace('[totaal]', total);
    if (bar) bar.style.width = Math.round((shown / total) * 100) + '%';
  }

  /* Meldingen voor schermlezers na Laad meer (fase 2, B2-09) */
  function announce(text) {
    var live = document.getElementById('pip-col-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'pip-col-live';
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  function loadMore(link) {
    var section = document.querySelector('[data-pip-col]');
    var sectionId = section && section.getAttribute('data-section-id');
    var grid = document.getElementById('product-grid');
    if (!sectionId || !grid) return true;
    var url = link.getAttribute('href');
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    link.classList.add('is-loading');
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        var firstNew = items[0] || null;
        items.forEach(function (li) { grid.appendChild(li); });
        var oldWrap = document.querySelector('[data-pip-more-wrap]');
        var newWrap = doc.querySelector('[data-pip-more-wrap]');
        if (oldWrap && newWrap) {
          var prev = newWrap.querySelector('.pip-col__prev');
          if (prev) prev.remove();
          oldWrap.replaceWith(newWrap);
          updateSeen(newWrap);
        } else if (oldWrap) {
          var btn = oldWrap.querySelector('[data-pip-more]');
          if (btn) btn.remove();
          updateSeen(oldWrap);
        }
        applyView();
        styleHearts();
        /* focus naar het eerste nieuwe product, zodat toetsenbordgebruikers niet bovenaan de pagina belanden (fase 2, B2-09) */
        var firstLink = firstNew && firstNew.querySelector('a[href]');
        if (firstLink) { try { firstLink.focus({ preventScroll: true }); } catch (err) {} }
        var seenEl = document.querySelector('[data-pip-seen]');
        announce(items.length + ' producten geladen.' + (seenEl ? ' ' + seenEl.textContent : ''));
      })
      .catch(function () {
        link.classList.remove('is-loading');
        window.location.href = link.getAttribute('href');
      });
    return false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var v = t.closest('[data-pipv2-view]');
    if (v) {
      var val = v.getAttribute('data-pipv2-view');
      if (val.charAt(0) === 'm') write(KEY_M, val); else write(KEY_D, val);
      applyView();
      return;
    }
    var more = t.closest('[data-pip-more]');
    if (more) {
      if (loadMore(more) === false) e.preventDefault();
    }
  });

  applyView();
  styleHearts();

  if ('MutationObserver' in window) {
    var pipPending = null;
    new MutationObserver(function () {
      if (pipPending) return;
      pipPending = setTimeout(function () {
        pipPending = null;
        applyView();
        styleHearts();
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
